export default {
  getComments: () => [
    {
      id: 1,
      author: "Peter",
      comment: "01 - Lorem ",
      question: true,
      reply: [{ id: 1, author: "Andy", reply: "reply 101" }],
    },
    {
      id: 2,
      author: "Robert",
      comment: "02 - Lorem Lorem",
      question: false,
      reply: [
        { id: 1, reply: "reply 201" },
        { id: 2, reply: "reply 202" },
        { id: 3, reply: "reply 203" },
        { id: 4, reply: "reply 204" },
        { id: 5, reply: "reply 205" },
        { id: 6, reply: "reply 206" },
        { id: 7, reply: "reply 207" },
        { id: 8, reply: "reply 208" },
        { id: 9, reply: "reply 209" },
        { id: 10, reply: "reply 210" },
        { id: 11, reply: "reply 211" },
      ],
    },
    {
      id: 3,
      author: "william",
      comment: "03 - Lorem Lorem Lorem.",
      question: false,
      reply: [
        { id: 1, reply: "reply 301" },
        { id: 2, reply: "reply 302" },
        { id: 3, reply: "reply 303" },
      ],
    },
    {
      id: 4,
      author: "richard",
      comment: "04 - Lorem Lorem Lorem Lorem.",
      question: true,
      reply: [
        { id: 1, reply: "reply 401" },
        { id: 2, reply: "reply 402" },
        { id: 3, reply: "reply 403" },
        { id: 4, reply: "reply 404" },
        { id: 5, reply: "reply 405" },
        { id: 6, reply: "reply 406" },
        { id: 7, reply: "reply 407" },
        { id: 8, reply: "reply 408" },
        { id: 9, reply: "reply 409" },
      ],
    },
    {
      id: 5,
      author: "Peter",
      comment: "Lorem 5.",
      question: false,
      reply: [],
    },
    {
      id: 6,
      author: "mary",
      comment: "Lorem 6666. Lorem 6666. Lorem 6666. Lorem 6666.",
      question: true,
      reply: [
        { id: 1, reply: "reply 601, reply 601, reply 601, reply 601" },
        { id: 2, reply: "reply 602" },
        { id: 3, reply: "reply 603" },
      ],
    },
    {
      id: 7,
      author: "nancy",
      comment: "Lorem 7.",
      question: true,
      reply: [],
    },
    {
      id: 8,
      author: "Peter",
      question: false,
      comment:
        "08-Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident non at iste fugiat eligendi aliquam cum voluptate perferendis repudiandae rerum. 08-Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident non at iste fugiat eligendi aliquam cum voluptate perferendis repudiandae rerum. 08-Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident non at iste fugiat eligendi aliquam cum voluptate perferendis repudiandae rerum. 08-Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident non at iste fugiat eligendi aliquam cum voluptate perferendis repudiandae rerum",
      reply: [
        { id: 1, reply: "reply 801, reply 801" },
        { id: 2, reply: "reply 802" },
      ],
    },
    // {
    //   id: 9,
    //   comment: 'Lorem 999.',
    // question: false,//
    // reply: [
    //   ]
    // },
    // {
    //   id: 10,
    //   comment: 'Lorem 10.',
    // question: false,//
    // reply: [
    //     {id: 1, reply: 'reply 1001'},
    //     {id: 2, reply: 'reply 1002'},
    //     {id: 3, reply: 'reply 1003'},
    //   ]
    // },
    // {
    //   id: 11,
    //   comment: 'Lorem 11.',
    // question: false,//
    // reply: [
    //   ]
    // },
    // {
    //   id: 12,
    //   comment: 'Lorem 12.',
    // question: false,//
    // reply: [
    //     {id: 1, reply: 'reply 1201'},
    //     {id: 2, reply: 'reply 1202'},
    //     {id: 3, reply: 'reply 1203'},
    //     {id: 4, reply: 'reply 1204'},
    //     {id: 5, reply: 'reply 1205'},
    //   ]
    // },
    // {
    //   id: 13,
    //   comment: 'Lorem 13.',
    // question: false,//
    // reply: [
    //   ]
    // }
  ],
};
